
      var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCredit = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#credit_0858d79b663046c1__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24 3.75c0 .844-.67 1.622-1.8 2.25-1.364.755-3.398 1.29-5.733 1.448a6.728 6.728 0 0 0-.53-.234C14.091 6.441 11.634 6 9 6c-.39 0-.769.01-1.148.028L7.8 6C6.67 5.372 6 4.594 6 3.75 6 1.678 10.031 0 15 0s9 1.678 9 3.75zM7.533 7.552C8.01 7.519 8.503 7.5 9 7.5c2.916 0 5.503.577 7.148 1.472C17.311 9.605 18 10.392 18 11.25c0 .188-.033.37-.098.548-.216.62-.797 1.186-1.641 1.665-.005.004-.014.004-.019.009-.014.01-.028.014-.042.023-1.64.91-4.256 1.5-7.2 1.5-2.794 0-5.292-.53-6.947-1.364-.089-.042-.173-.089-.258-.136C.67 12.872 0 12.094 0 11.25c0-1.631 2.503-3.023 6-3.534a21.63 21.63 0 0 1 1.533-.164zM19.5 11.25c0-1.027-.497-1.87-1.13-2.503 1.327-.206 2.54-.534 3.572-.961.764-.319 1.477-.713 2.058-1.195V8.25c0 .905-.773 1.74-2.053 2.386-.684.347-1.519.642-2.456.867.004-.084.009-.164.009-.248v-.005zm-1.5 4.5c0 .844-.67 1.622-1.8 2.25-.084.047-.169.09-.258.136C14.292 18.97 11.794 19.5 9 19.5c-2.944 0-5.56-.59-7.2-1.5C.67 17.372 0 16.594 0 15.75v-1.66c.586.483 1.294.877 2.058 1.196C3.909 16.059 6.366 16.5 9 16.5c2.634 0 5.09-.44 6.942-1.214a9.36 9.36 0 0 0 1.05-.511c.286-.16.553-.338.806-.525.07-.052.136-.108.202-.16v1.66zm1.5 0v-2.714c.89-.197 1.71-.445 2.442-.75.764-.319 1.477-.713 2.058-1.195v1.659c0 .492-.234.984-.698 1.448-.764.764-2.11 1.393-3.811 1.8.004-.08.009-.164.009-.248zM9 21c2.634 0 5.09-.44 6.942-1.214.764-.319 1.477-.713 2.058-1.195v1.659C18 22.322 13.969 24 9 24s-9-1.678-9-3.75v-1.66c.586.483 1.294.877 2.058 1.196C3.909 20.559 6.366 21 9 21z",
  fill: "var(--theme-primary, #810ea9)"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "credit_0858d79b663046c1__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));

      const __svgRaw = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <g clip-path=\"url(#wpbhxejmza)\">\r\n        <path d=\"M24 3.75c0 .844-.67 1.622-1.8 2.25-1.364.755-3.398 1.29-5.733 1.448a6.728 6.728 0 0 0-.53-.234C14.091 6.441 11.634 6 9 6c-.39 0-.769.01-1.148.028L7.8 6C6.67 5.372 6 4.594 6 3.75 6 1.678 10.031 0 15 0s9 1.678 9 3.75zM7.533 7.552C8.01 7.519 8.503 7.5 9 7.5c2.916 0 5.503.577 7.148 1.472C17.311 9.605 18 10.392 18 11.25c0 .188-.033.37-.098.548-.216.62-.797 1.186-1.641 1.665-.005.004-.014.004-.019.009-.014.01-.028.014-.042.023-1.64.91-4.256 1.5-7.2 1.5-2.794 0-5.292-.53-6.947-1.364-.089-.042-.173-.089-.258-.136C.67 12.872 0 12.094 0 11.25c0-1.631 2.503-3.023 6-3.534a21.63 21.63 0 0 1 1.533-.164zM19.5 11.25c0-1.027-.497-1.87-1.13-2.503 1.327-.206 2.54-.534 3.572-.961.764-.319 1.477-.713 2.058-1.195V8.25c0 .905-.773 1.74-2.053 2.386-.684.347-1.519.642-2.456.867.004-.084.009-.164.009-.248v-.005zm-1.5 4.5c0 .844-.67 1.622-1.8 2.25-.084.047-.169.09-.258.136C14.292 18.97 11.794 19.5 9 19.5c-2.944 0-5.56-.59-7.2-1.5C.67 17.372 0 16.594 0 15.75v-1.66c.586.483 1.294.877 2.058 1.196C3.909 16.059 6.366 16.5 9 16.5c2.634 0 5.09-.44 6.942-1.214.366-.15.717-.323 1.05-.511.286-.16.553-.338.806-.525.07-.052.136-.108.202-.16v1.66zm1.5 0v-2.714c.89-.197 1.71-.445 2.442-.75.764-.319 1.477-.713 2.058-1.195v1.659c0 .492-.234.984-.698 1.448-.764.764-2.11 1.393-3.811 1.8.004-.08.009-.164.009-.248zM9 21c2.634 0 5.09-.44 6.942-1.214.764-.319 1.477-.713 2.058-1.195v1.659C18 22.322 13.969 24 9 24s-9-1.678-9-3.75v-1.66c.586.483 1.294.877 2.058 1.196C3.909 20.559 6.366 21 9 21z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n    </g>\r\n    <defs>\r\n        <clipPath id=\"wpbhxejmza\">\r\n            <path fill=\"#fff\" d=\"M0 0h24v24H0z\"/>\r\n        </clipPath>\r\n    </defs>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/credit.0858d79b663046c1c7245b4890e7e3c1.svg"),
        {
          React: SvgCredit,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      